(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinr-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pinr-hero-carousel')) {
  class PinrHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.slides = [...this.querySelectorAll('.pinr-carousel__slide')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.stage = this.querySelector('.pinr-carousel__stage');
      this.status = this.querySelector('.pinr-carousel__status');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.visible = true;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      this.querySelector('[data-prev]').addEventListener('click', () => this.select(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.select(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i, true), options));
      this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, options);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1);
        this.select(target, true);
      }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => {
        if (!this.contains(event.relatedTarget) && event.target !== this.toggle) { this.paused = true; this.updateToggle(); this.schedule(); }
      }, options);
      this.stage.addEventListener('pointerdown', event => { if (event.pointerType === 'touch' && event.isPrimary) this.touch = { x: event.clientX, y: event.clientY }; }, options);
      this.stage.addEventListener('pointerup', event => {
        if (!this.touch || event.pointerType !== 'touch') return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.3) { this.suppressClickUntil = Date.now() + 400; this.select(this.index + (x < 0 ? 1 : -1), true); }
      }, options);
      this.stage.addEventListener('pointercancel', () => { this.touch = null; }, options);
      this.stage.addEventListener('click', event => { if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.updateToggle(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (i >= 0) this.select(i, true);
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
      }
      this.classList.add('is-ready');
      this.select(0, false);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
    select(target, manual) {
      const next = (target + this.slides.length) % this.slides.length;
      if (manual) {
        this.paused = true;
        if (this.slides[this.index].contains(document.activeElement)) this.stage.focus({ preventScroll: true });
      }
      this.index = next;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.dataset.active = String(active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[i].setAttribute('aria-current', String(active));
      });
      if (manual) this.status.textContent = this.slides[next].getAttribute('aria-label') + ': ' + this.slides[next].dataset.title;
      this.updateToggle();
      this.schedule();
    }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || !this.visible || document.hidden || !this.isConnected) return;
      this.timer = setTimeout(() => this.select(this.index + 1, false), this.interval);
    }
  }
  customElements.define('pinr-hero-carousel', PinrHeroCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('pinrshelf-variant-title')) {
    customElements.define('pinrshelf-variant-title', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const scope = this.closest('product-component');
        scope?.addEventListener('change', (event) => {
          const picker = event.target.closest('variant-picker');
          if (!picker || picker.dataset.productId !== this.dataset.productId) return;
          const options = picker.getAllSelectedOptions();
          const suffix = options.map((option) => option.value).filter(Boolean).join(' / ');
          this.textContent = suffix ? ' — ' + suffix : '';
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
